import React from 'react';
import './GeneratingCards.css';

interface GeneratingCardsProps {
  message?: string;
  stage?: 'processing' | 'generating';
}

const GeneratingCards: React.FC<GeneratingCardsProps> = ({
  message,
  stage = 'generating',
}) => {
  const getDefaultMessage = () => {
    switch (stage) {
      case 'processing':
        return 'Processing content...';
      case 'generating':
        return 'Generating cards...';
      default:
        return 'Generating cards...';
    }
  };

  return (
    <div className="generating-cards-container">
      <div className="generating-cards-spinner"></div>
      <span className="generating-cards-message">
        {message || getDefaultMessage()}
      </span>
    </div>
  );
};

export default GeneratingCards;
